module.exports = __webpack_public_path__ + "img/bmbf_logo_neu_skaliert.4a358e76.svg";